<template>
  <div>
    <v-btn class="mx-2" x-small color="primary" dark @click="gotoRekapitulasiNilai()">Rekapitulasi Nilai</v-btn>
    <v-btn class="mx-2" x-small color="primary" dark @click="gotoRekapitulasiLogbook()">Rekapitulasi Logbook</v-btn>
    <v-btn class="mx-2" x-small color="primary" dark @click="gotoRekapitulasiDaftarHadir()"
      >Rekapitulasi Daftar Hadir</v-btn
    >
    <v-btn class="mx-2" x-small color="primary" dark @click="gotoRekapitulasiTingkatSupervisi()"
      >Tingkat Supervisi</v-btn
    >
    <router-link
      :to="{ name: 'UniversitasSuratSelesai', params: { praktik_id: praktik_id } }"
      style="text-decoration: none"
    >
      <v-btn class="mx-2" x-small color="success" dark>Surat Selesai Praktik</v-btn>
    </router-link>
    <v-btn class="mx-2" x-small color="primary" dark @click="gotoRekapitulasiUjian()">Ujian</v-btn>
  </div>
</template>

<script>
import { axiosPostAuth, axiosGetAuth } from '@/utils/axios'
export default {
  props: {
    data: { type: Object, default: () => ({}) },
    praktik_id: { type: String, default: () => null },
  },
  methods: {
    gotoRekapitulasiNilai() {
      if (this.data.profesi == 'Dokter') {
        window.open(
          process.env.VUE_APP_APIROOT +
            '/api/ReadFile/viewRekapitulasiDokter/' +
            this.praktik_id +
            '/' +
            this.$store.state.token,
          '_blank',
        )
      } else if (this.data.profesi == 'PPDS') {
        window.open(
          process.env.VUE_APP_APIROOT +
            '/api/ReadFile/viewRekapitulasiNilaiPPDS/' +
            this.praktik_id +
            '/' +
            this.$store.state.token,
          '_blank',
        )
      } else if (this.data.profesi == 'Keperawatan,Kebidanan, dan Tenaga Kesehatan Lain') {
        window.open(
          process.env.VUE_APP_APIROOT +
            '/api/ReadFile/viewRekapitulasiNilaiKeperawatanLain/' +
            this.praktik_id +
            '/' +
            this.$store.state.token,
          '_blank',
        )
      }
    },
    gotoRekapitulasiLogbook() {
      window.open(
        process.env.VUE_APP_APIROOT +
          '/api/ReadFile/viewRekapitulasiLogbook/' +
          this.praktik_id +
          '/' +
          this.$store.state.token,
        '_blank',
      )
    },
    gotoRekapitulasiDaftarHadir() {
      window.open(
        process.env.VUE_APP_APIROOT +
          '/api/ReadFile/viewRekapitulasiDaftarHadir/' +
          this.praktik_id +
          '/' +
          this.$store.state.token,
        '_blank',
      )
    },
    gotoRekapitulasiTingkatSupervisi() {
      window.open(
        process.env.VUE_APP_APIROOT +
          '/api/ReadFile/viewRekapitulasiTingkatSupervisi/' +
          this.praktik_id +
          '/' +
          this.$store.state.token,
        '_blank',
      )
    },
    gotoRekapitulasiUjian() {
      window.open(
        process.env.VUE_APP_APIROOT +
          '/api/ReadFile/viewRekapitulasiUjian/' +
          this.praktik_id +
          '/' +
          this.$store.state.token,
        '_blank',
      )
    },
  },
}
</script>